import EXERCISES_UI_ACTION from '../../constants/action'
import EXERCISES_UI_PATH from '../../constants/path'
import { getPageExerciseUiSelect } from '../../selectors/get-page'
import setReduxAction from '../../../redux/actions/set'
import { getActionStrReduxUtil } from '../../../redux/utils/get-action-str'

export function updatePageExerciseUiAction (value) {
  return setReduxAction({
    type: getActionStrReduxUtil(EXERCISES_UI_ACTION.UPDATE_PAGE, value),
    payload: {
      path: EXERCISES_UI_PATH.PAGE,
      value
    }
  })
}

export function incrementPageExerciseUiAction () {
  return (dispatch, getState) => {
    const page = getPageExerciseUiSelect(getState())
    dispatch(updatePageExerciseUiAction(page + 1))
  }
}
